import AttackMoveToOrder from './attackMoveToOrder';


export default class PatrolOrder extends AttackMoveToOrder
{
  departureX!: number;
  departureY!: number;

  constructor(params: {x: number, y: number})
  {
    super(params);
    this.color = 'orange';
  }

  update(modifier: number): AttackMoveToOrder
  {
    if (this.departureX === undefined)
    {
      this.departureX = this.getElement().x;
      this.departureY = this.getElement().y;
    }
    super.update(modifier);
    return this;
  }

  onComplete(): void
  {
    if(this.isLastOrder())
    {
      this.behaviour.queueOrder(new PatrolOrder({
        x: this.departureX,
        y: this.departureY,
      }));
    }
  }

  isPossible(): boolean
  {
    return (this.getElement()?.moveSpeedMax > 0); // can't move: "Game over man, game over!"
  }
}